import { defineComponent as _defineComponent } from 'vue'
import { onUnmounted, ref, watch, computed } from 'vue'
import { api } from "@/main";
import { Calendar, CalendarHolder, Subscription } from "@/api";
import Card from "@/components/Card.vue";
import DynamicForm from "@/components/DynamicForm.vue";
import moment from 'moment'
import EditableTable from "@/components/EditableTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarDashboard',
  props: ['household', 'calendarHolderId'],
  emits: ['breadcrumbs', 'menuItems'],
  setup(__props, { emit }) {

const props = __props




const calendarHolder = ref<CalendarHolder | null>(null);
let calendarHolderSubscription: Subscription | null = null;
const calendars = ref<Calendar[]>([]);
const calendarColors = computed(() => {
  const colors = {}
  calendars.value.forEach(calendar => {
    colors[calendar.id] = calendar.color;
  })
  return colors;
})
let calendarsSubscription: Subscription | null = null;
const calendarEvents = ref<any[]>([]);

let calendarEventsSubscriptions: Subscription[] = [];

const createCalendarDialog = ref(false);
const rules = {
  required: (value: string) => !!value || 'Required',
}

watch(
  () => props.calendarHolderId,
  (newCalendarHolderId) => {
    if (calendarHolderSubscription)
      api.unsubscribe(calendarHolderSubscription);
    calendarHolder.value = null;

    calendarHolderSubscription = api.calendar.subscribeToCalendarHolder(newCalendarHolderId, (newCalendarHolder) => {
        if (!newCalendarHolder)
          return;

        calendarHolder.value = newCalendarHolder;
        emit('menuItems', []);

        emit('breadcrumbs', [{
          text: calendarHolder.value.name,
          icon: 'mdi-calendar-multiple',
          to: '/h/' + props.household.id + '/calendar/' + newCalendarHolderId
        }]);
      },
    );

    calendarEventsSubscriptions.forEach(subscription => { api.unsubscribe(subscription); });
    calendarEventsSubscriptions = [];

    if (calendarsSubscription)
      api.unsubscribe(calendarsSubscription);
    calendars.value = [];

    calendarsSubscription = api.calendar.subscribeToCalendars(newCalendarHolderId, (newObject) => {
      let index = null;
      for (let i = 0; i < calendars.value.length; i++)
        if (calendars.value[i].id === newObject.id)
          index = i;

      if (index !== null) {
        if (newObject.deletedTimestamp)
          calendars.value.splice(index, 1);
        else
          calendars.value.splice(index, 1, newObject);
      } else {
        calendars.value.push(newObject);
        calendarEventsSubscriptions.push(api.calendar.subscribeToCalendarEvents(newObject.id, (event) => {
          const normalizedEvent = {
            id: event.id,
            name: event.name,
            start: event.fullDayStartDate ? event.fullDayStartDate : moment(event.start).format('YYYY-MM-DDTHH:mm:ss'),
            end: event.fullDayEndDate ? event.fullDayEndDate : moment(event.end).format('YYYY-MM-DDTHH:mm:ss'),
            color: calendarColors.value[event.calendarId],
            timed: !event.fullDayStartDate,
          }
          let index = null;
          for (let i = 0; i < calendarEvents.value.length; i++)
            if (calendarEvents.value[i].id === event.id)
              index = i;
          if (index !== null) {
            if (event.deletedTimestamp)
              calendarEvents.value.splice(index, 1);
            else
              calendarEvents.value.splice(index, 1, normalizedEvent);
          } else {
            calendarEvents.value.push(normalizedEvent);
          }
        }))
      }
    });
  },
  { immediate: true }
);

onUnmounted(() => {
  if (calendarHolderSubscription)
    api.unsubscribe(calendarHolderSubscription);
  if (calendarsSubscription)
    api.unsubscribe(calendarsSubscription);
});


return { __sfc: true,props, emit, calendarHolder, calendarHolderSubscription, calendars, calendarColors, calendarsSubscription, calendarEvents, calendarEventsSubscriptions, createCalendarDialog, rules, api, Card, DynamicForm, EditableTable }
}

})